import { useEffect, useMemo, useState } from 'react';
import { playHaptic } from '../haptics';
import { ScreenHeader } from '../components/ScreenHeader';
import { formatBalance, getBalance } from '../balance';
import { buildBoard } from '../leaderboard';

const img = (name) => `${process.env.PUBLIC_URL}/img/${name}`;

const SPARKS = {
  1: [
    { x: '74%', y: '10px', size: 5, delay: '0.12s', duration: '2.15s' },
    { x: '36%', y: 'calc(100% - 13px)', size: 3, delay: '0.88s', duration: '1.68s' },
    { x: '14%', y: '20px', size: 4, delay: '1.41s', duration: '2.42s' },
  ],
  2: [
    { x: '82%', y: '14px', size: 4, delay: '0.37s', duration: '2.63s' },
    { x: '21%', y: 'calc(100% - 9px)', size: 3, delay: '1.18s', duration: '1.94s' },
    { x: '61%', y: '8px', size: 5, delay: '1.92s', duration: '2.28s' },
  ],
  3: [
    { x: '57%', y: '7px', size: 3, delay: '0.61s', duration: '2.07s' },
    { x: '47%', y: 'calc(100% - 15px)', size: 5, delay: '1.55s', duration: '2.81s' },
    { x: '12%', y: '18px', size: 4, delay: '0.24s', duration: '1.76s' },
  ],
};

function Leaderboard() {
  const [period, setPeriod] = useState('week');
  const [energy, setEnergy] = useState(getBalance);
  const rows = useMemo(() => buildBoard(period, energy), [period, energy]);

  useEffect(() => {
    const update = () => setEnergy(getBalance());
    window.addEventListener('balance-change', update);
    return () => window.removeEventListener('balance-change', update);
  }, []);

  return (
    <div className="app home board-page">
      <ScreenHeader />
      <h1 className="page-title">Лидерборд</h1>

      <div className="segment" role="tablist" aria-label="Период">
        <span className="segment-pill" style={{ '--seg': period === 'week' ? 0 : 1 }} />
        <button
          type="button"
          role="tab"
          aria-selected={period === 'week'}
          className={period === 'week' ? 'active' : ''}
          data-cuelume-toggle
          onClick={() => {
            if (period === 'week') return;
            playHaptic('selection');
            setPeriod('week');
          }}
        >
          Неделя
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={period === 'month'}
          className={period === 'month' ? 'active' : ''}
          data-cuelume-toggle
          onClick={() => {
            if (period === 'month') return;
            playHaptic('selection');
            setPeriod('month');
          }}
        >
          Месяц
        </button>
      </div>

      <ol className="lb-list">
        {rows.map((row) => (
          <li
            key={row.id}
            className={[
              'lb-row',
              row.place <= 3 ? `top top-${row.place}` : '',
              row.me ? 'me' : '',
            ].join(' ')}
          >
            {row.place <= 3 && !row.me && (
              <>
                <span className="lb-ring" aria-hidden="true" />
                {SPARKS[row.place].map((spark, index) => (
                  <span
                    key={index}
                    className="lb-spark"
                    aria-hidden="true"
                    style={{
                      '--sx': spark.x,
                      '--sy': spark.y,
                      '--ss': `${spark.size}px`,
                      '--sdelay': spark.delay,
                      '--sdur': spark.duration,
                    }}
                  />
                ))}
              </>
            )}
            <span className="lb-place">{row.place}</span>
            <span className="lb-avatar" aria-hidden="true">
              <img src={img('icon-user-solo.svg')} alt="" draggable="false" />
            </span>
            <span className="lb-who">
              <span className="lb-name">{row.name}</span>
              <span className="lb-id">{row.id}</span>
            </span>
            <span className="lb-score">{formatBalance(row.score)}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default Leaderboard;
